import Styled from './headerDashboard.module.css'
import { Link } from 'react-router-dom'
import { FiLogOut, FiSettings, FiPlusCircle } from 'react-icons/fi'
import { HeaderProps } from '../../Context/types'
import { LandingContext } from '../../Context'
import { useContext } from 'react'
import Loading from '../Loading'

function HeaderDashboard({ page }: HeaderProps) {
    const { handleSignOut, loading, websiteSettings } = useContext(LandingContext)

    return (
        <header className={Styled.header}>
            <Link to="/" className={Styled.logo}>
                {loading ? <Loading /> : <img src={websiteSettings.logo.url} alt="Logo" />}
            </Link>
            <nav>
                <Link to="/dashboard/configuracoes" className={page === "settings" ? Styled.anchorActive : ''}>
                    <FiSettings />
                    <span>Configurações</span>
                </Link>
                <Link to="/dashboard/depoimentos" className={page === "feedbacks" ? Styled.anchorActive : ''}>
                    <FiPlusCircle />
                    <span>Depoimentos</span>
                </Link>
            </nav>
            <button className={Styled.logoOut} onClick={handleSignOut}>
                <FiLogOut />
            </button>
        </header>
    )
}

export default HeaderDashboard